export enum PosFramesHistoryType {
    yield = 'yield',
    pnl   = 'pnl'
}

export type PosFramesHistory = number[];
